var exports = {
  "kL": "x804f0401--a4ff48--container",
  "Qs": "x804f0401--a4ff48--content",
  "Sl": "x804f0401--a4ff48--image",
  "h_": "x804f0401--a4ff48--description",
  "ne": "x804f0401--a4ff48--controls",
};

module.exports = exports;
